import type { DemoKey } from './keys';

export const te: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'జ్యామితి · 3D',
  'panel.figure': 'ఆకారం',
  'panel.dims': 'కొలతలు',
  'panel.style': 'రూపం',
  'panel.lines': 'ప్రత్యేక రేఖలు',
  'style.body': 'శరీరం',
  'style.line': 'రేఖ',
  'style.cut': 'విభాగం',
  'style.labels': 'శీర్షాల లేబుళ్ళు',
  'group.face': 'తల కర్ణాలు / జనకాలు',
  'group.space': 'కర్ణాలు / అక్షాలు / మధ్యస్థాలు',
  'split.label': 'విభాగం',
  'btn.animate': 'యానిమేట్',
  'btn.reset': 'రీసెట్',
  'hint.line1': 'తిప్పడానికి లాగండి · జూమ్ కోసం స్క్రోల్',
  'hint.line2': 'ఎంచుకోవడానికి రేఖను క్లిక్ చేయండి',
  'fig.cuboid': 'దీర్ఘఘనం',
  'fig.cube': 'ఘనం',
  'fig.triPrism': 'త్రిభుజాకార పట్టం',
  'fig.hexPrism': 'షట్భుజాకార పట్టం',
  'fig.tetrahedron': 'చతుర్భుజం',
  'fig.squarePyramid': 'చతురస్రాకార పిరమిడ్',
  'fig.cylinder': 'స్థూపం',
  'fig.cone': 'శంకువు',
  'fig.sphere': 'గోళం',
  'fig.frustumPyramid': 'పిరమిడ్ ఛిన్నక',
  'fig.frustumCone': 'శంకు ఛిన్నక',
  'dim.length': 'పొడవు',
  'dim.width': 'వెడల్పు',
  'dim.height': 'ఎత్తు',
  'dim.side': 'భుజం',
  'dim.radius': 'వ్యాసార్థం',
  'dim.r1': 'క్రింది వ్యాసార్థం',
  'dim.r2': 'పైన వ్యాసార్థం',
  'dim.sideBase': 'భూమి భుజం',
  'dim.sideTop': 'పై భుజం',
  'info.face': 'తలం',
  'info.center': 'కేంద్రం గుండా',
  'info.diagonal': 'కర్ణం',
  'info.axial': 'అక్షీయ కర్ణం',
  'info.diameter': 'వ్యాసం',
  'info.generator': 'జనకం',
  'info.axis': 'అక్షం',
  'info.height': 'ఎత్తు',
  'info.median': 'మధ్యస్థం',
  'info.apothem': 'అపోతెం',
  'info.diameterBase': 'భూమి వ్యాసం',
  'info.diameterTop': 'పై వ్యాసం',
};
